import { Table, Typography } from '@mui/material';
import React from 'react';
import TabelleEntries from '../../../TabelleEntries';
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from '../../../../lib/traduzioni';
const {logger} = useBSSLogger();

//tab con i dati di fatturazione legati all'ordine
const TabDatifatt = ({ ordine, tabObj }) => {

    const { datiint = {} } = ordine;

    const {
        gruppo = null, ragionesociale, nome, cognome, partitaiva, codicefiscale, vies, pec, codiceSdi, email, prefissotelefono, numerotelefono, indirizzofatturazione, civico, cap, citta, provincia, nazione

    } = datiint;

    let {anagrafica = null} = datiint;

    anagrafica = gruppo ?? anagrafica ?? {};

    const { tipopersonafg = {} } = anagrafica;

    let tipopersona = tipopersonafg.value ?? null;

    const contatti = { email, telefono: `${prefissotelefono} ${numerotelefono}` };
    const indirizzo = { indirizzo: `${indirizzofatturazione}, ${civico}`, localita: `${cap} ${citta} (${provincia})`/*, ${nazione?.iso}`*/ };
    const datiComuni = { vies, pec, codicesdi: codiceSdi };
    let datiAnagrafici = { ragionesociale, nome, cognome, partitaiva, codicefiscale };

    if (tipopersona !== null) {
        tipopersona = tipopersona.toUpperCase();
        if (tipopersona === 'FISICA') {
            datiAnagrafici = { nome, cognome, codicefiscale };
        }

        if (tipopersona === 'FISICAI') {
            datiAnagrafici = { nome, cognome, piva };
        }

        if (['GIURIDICA', 'PA'].includes(tipopersona)) {
            datiAnagrafici = { piva, ragionesociale };
        }

    }

    const tabelle = {
        [__t("datianagrafici")]: { ...datiAnagrafici, ...datiComuni },
        [__t("indirizzo")]: indirizzo,
        [__t("contatti")]: contatti
    };


    return (
        <>
            <Typography variant={"body1"}>
                <TabelleEntries wrapped tabelle={tabelle} />
            </Typography>

        </>
    );
};

export default TabDatifatt;